export var TooltipStyle;
(function (TooltipStyle) {
    TooltipStyle["CLICKABLE"] = "CLICKABLE";
    TooltipStyle["HOVER"] = "HOVER";
})(TooltipStyle || (TooltipStyle = {}));
//# sourceMappingURL=TooltipStyle.js.map